import React from 'react'
import { Link } from 'react-router-dom';
import CloseIcon from './../../assets/images/icon/close.png';

const TermsAndConditions = () => {
    return (
        <section className="privacy-policy">
            <Link to="/#contact" className="mt-0" style={{ background: '#f7f8fc' }}>
                <img className="close-img" src={CloseIcon} alt="Close" />
            </Link>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="page-header">
                            <h1>Terms & Conditions</h1>
                            <p align="justify">These Terms & Conditions ("Terms") govern your use of the website and services provided by Vision Workspaces, located at Karmayogi Corporate Park, Orange Street, Plot No 7, Bhau Saheb Survey Nagar, Trimurtee Nagar, Nagpur, 440022. By accessing or using our website or booking our services, you agree to be bound by these Terms.</p>

                            <p align="justify">If you do not agree to these Terms, please do not use our website or services.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="privacy-policy-content">
                            <div className="privacy-policy-item">
                                <h2>1. Services Offered</h2>
                                <p align="justify">
                                    Vision Workspaces provides flexible workspace solutions including but not limited to:
                                </p>
                                <ul>
                                    <li>Managed Offices</li>
                                    <li>Private Cabins</li>
                                    <li>Dedicated Desks</li>
                                    <li>Meeting Rooms</li>
                                    <li>Conference Halls</li>
                                    <li>Virtual Office Services</li>
                                </ul>
                                <p align="justify">Service availability may vary and is subject to change without notice.</p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>2. Eligibility</h2>
                                <p align="justify">
                                    You must be at least 18 years old to book or use our services. By using our services, you confirm that you have the legal authority to enter into this agreement.</p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>3. Bookings and Payments</h2>
                                <ul>
                                    <li>All bookings must be made in advance through our website, phone, or in person.</li>
                                    <li>Payment terms (full or partial) may vary by service type.</li>
                                    <li>Accepted payment methods include UPI, bank transfer, cash, or other options specified at the time of booking.</li>
                                    <li>Non-refundable fees may apply for certain services, especially Virtual Offices and Event Halls.</li>
                                    <li>Late payments may result in service suspension or cancellation</li>
                                </ul>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>4. Cancellations and Refunds</h2>
                                <ul>
                                    <li>Cancellations must be made at least 24–48 hours in advance (depending on the service booked).</li>
                                    <li>Refunds are subject to our refund policy and may be partial or fully non-refundable based on service and notice period.</li>
                                    <li>No-shows or last-minute cancellations may incur full charges.</li>
                                </ul>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>5. User Conduct</h2>
                                <p align="justify">
                                    By using our services, you agree to:
                                </p>
                                <ul>
                                    <li>Use the space only for legal and professional purposes</li>
                                    <li>Respect the property, facilities, staff, and other clients</li>
                                    <li>Not engage in disruptive, illegal, or unethical activities</li>
                                    <li>Leave the space clean and damage-free after use</li>
                                </ul>
                                <p align="justify">Vision Workspaces reserves the right to terminate access or refuse service to individuals who violate these terms.</p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>6. Liability</h2>
                                <p align="justify">
                                    Vision Workspaces will not be liable for:
                                </p>
                                <ul>
                                    <li>Loss or damage of personal belongings</li>
                                    <li>Business losses or missed opportunities due to service interruptions</li>
                                    <li>Acts of third parties, theft, or accidents within the premises</li>
                                </ul>
                                <p align="justify">We strongly recommend not leaving valuable items unattended in shared spaces.</p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>7. Intellectual Property</h2>
                                <p align="justify">
                                    All content on this website (text, logos, images, etc.) is the property of Vision Workspaces and is protected by applicable copyright and trademark laws. You may not copy, modify, or reproduce any content without written permission.
                                </p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>8. Privacy Policy</h2>
                                <p align="justify">
                                    Your use of our website and services is also governed by our <a href="/privacy-policy">Privacy Policy</a>, which explains how we collect, use, and protect your personal data.
                                </p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>9. Changes to Terms</h2>
                                <p align="justify">
                                    Vision Workspaces reserves the right to update or modify these Terms at any time without prior notice. Changes will be posted on this page with the updated effective date. Continued use of the services after changes implies acceptance of the revised Terms.
                                </p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>10. Governing Law</h2>
                                <p align="justify">
                                    These Terms shall be governed by and interpreted in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts located in Nagpur, Maharashtra.
                                </p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>11. Contact Us</h2>
                                <p align="justify">
                                    If you have any questions about these Terms, please contact us:
                                </p>
                                <ul>
                                    <li>📧 <strong>Email: </strong>contact@visionworkspaces.com</li>
                                    <li>📞 <strong>Phone: </strong>+91 90826 67792</li>
                                    <li>🏢 <strong>Address: </strong>Karmayogi Corporate Park, Orange Street, Plot No 7,<br />
                                        Bhau Saheb Survey Nagar, Trimurtee Nagar, Nagpur, 440022</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TermsAndConditions
